/**
 * Map XLSX Group Header to text
 * @param header - String mapping header.
 * @param resources - Translation keys.
 * @return - Translated Group Header
 */

export const mapXlsxGroupHeader = (header: string, resources: any): string => {
    switch (header) {
        case 'Order':
            return resources.orderHistoryExcelOrderGroupHeader;
        case 'Address':
            return resources.orderHistoryExcelAddressGroupHeader;
        case 'OrderLines':
            return resources.orderHistoryExcelOrderLinesGroupHeader;
        case 'Shipping':
            return resources.orderHistoryExcelShippingGroupHeader;
        case 'Invoice':
            return resources.orderHistoryExcelInvoiceGroupHeader;
        default:
            return '';
    }
};
